import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-gray-950" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <CountdownTimer data-id="element-8" />
      <PurchaseSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <Footer data-id="element-12" />
      <SocialProofPopup data-id="element-13" />
    </div>;
}